import axios from 'axios';

export async function getAutochangeData(host: string) {
  const response = await axios.get(`https://${host}/autochange-data`);
  return response.data;
}
